/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteEvalRunRequest = {
  runId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteEvalRunRequest$inboundSchema: z.ZodType<
  DeleteEvalRunRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  run_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "run_id": "runId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteEvalRunRequest$Outbound = {
  run_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteEvalRunRequest$outboundSchema: z.ZodType<
  DeleteEvalRunRequest$Outbound,
  z.ZodTypeDef,
  DeleteEvalRunRequest
> = z.object({
  runId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    runId: "run_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteEvalRunRequestToJSON(
  deleteEvalRunRequest: DeleteEvalRunRequest,
): string {
  return JSON.stringify(
    DeleteEvalRunRequest$outboundSchema.parse(deleteEvalRunRequest),
  );
}
export function deleteEvalRunRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteEvalRunRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteEvalRunRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteEvalRunRequest' from JSON`,
  );
}
